import React from 'react';
import BaseExpander from 'Components/UI/VerticalExpander/LabeledVerticalExpander';
import PropTypes from 'prop-types';

const LabeledVerticalExpander = ({
  transitionSpeed,
  children,
  expanded,
  title,
  removeButton,
  firstElementFocusable,
  test,
  ...rest
}) => {
  let displayTitle = title;
  if (typeof title === 'string' && title.length > 50) {
    displayTitle = `${title.substring(0, 50)}...`;
  }
  return (
    <BaseExpander
      transitionSpeed={transitionSpeed}
      expanded={expanded}
      title={displayTitle}
      titleRight={removeButton}
      firstElementFocusable={firstElementFocusable}
      test={test}
      {...rest}
    >
      {children}
    </BaseExpander>
  );
};

LabeledVerticalExpander.propTypes = {
  transitionSpeed: PropTypes.number,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  title: PropTypes.node,
  removeButton: PropTypes.node.isRequired,
  firstElementFocusable: PropTypes.bool,
  additionalActions: PropTypes.array,
  test: PropTypes.string,
};

LabeledVerticalExpander.defaultProps = {
  transitionSpeed: 1,
  expanded: false,
  title: '',
  firstElementFocusable: false,
  additionalActions: [],
  test: '',
};

export default LabeledVerticalExpander;
